// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerImg":"Header_headerImg__akAgj","headerTitle":"Header_headerTitle__Vfl4P","headerDesc":"Header_headerDesc__lGOSq"};